import { Link } from "react-router-dom";
import { Reveal } from "@/components/common/Reveal";
import { ArrowRight } from "lucide-react";

export const CtaBand = () => (
    <section
        data-testid="cta-band"
        className="relative overflow-hidden bg-rz-deep px-6 md:px-12 py-20 lg:py-28"
    >
        <div
            className="absolute inset-0 opacity-20"
            style={{
                backgroundImage: "url('/images/pasture.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        />
        <div className="absolute inset-0 bg-rz-deep/70" />
        <div className="relative z-10 mx-auto max-w-[1400px] text-center">
            <Reveal>
                <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                    Nous sommes là pour vous
                </span>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="font-display mx-auto mt-5 max-w-4xl text-[clamp(2rem,5vw,4rem)] font-extrabold tracking-tight leading-[1.05] text-white">
                    Parlons de votre projet agricole ou équestre.
                </h2>
            </Reveal>
            <Reveal delay={0.2}>
                <Link
                    to="/contact"
                    data-testid="cta-band-button"
                    className="group mt-10 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-semibold text-rz-green transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/30"
                >
                    Nous contacter
                    <ArrowRight
                        size={18}
                        className="transition-transform duration-300 group-hover:translate-x-1"
                    />
                </Link>
            </Reveal>
        </div>
    </section>
);
